export class AnalyticsService {
    static logEvent(eventName) {
        // Disable
    }
}

export class AnalyticsEventName {
    static adsenseFailedToShow = 'adsense_failed_to_show'
    static openedFrom = 'opened_from'
}